<template>
  <div id="app" @click="appOnClick" @input="appOnInput">
    <NavigationBar v-if="loggedIn"/>
    <div id="wrapper">
      <SideBar v-if="loggedIn"/>
      <div id="content-wrapper" class="d-flex flex-column">
        <router-view></router-view>
      </div>
    </div>
    <SystemToasts />
  </div>
</template>

<script>
import SystemToasts from '@/components/SystemToasts'
import NavigationBar from '@/components/admin/NavigationBar'
import SideBar from '@/components/admin/SideBar'

export default {
  name: 'App',
  components: {
    NavigationBar,
    SideBar,
    SystemToasts
  },
  setup () {
    let alertFlg = false
    return {
      alertFlg
    }
  },
  computed: {
    loggedIn () {
      return this.$store.state.auth.loggedIn
    },
    isError () {
      return this.$store.getters['getErrorStatus']
    }
  },
  mounted () {
    // セッション監視
    setInterval(function () {
      if (this.$store.state.auth.loggedIn) {
        /*
        let dtDestroy = new Date()
        let dtAlert = new Date()
        dtDestroy.setMinutes(dtDestroy.getMinutes() - this.$setting.SESSION_TIME)
        dtAlert.setMinutes(dtAlert.getMinutes() - this.$setting.SESSION_TIME + this.$setting.SESSION_ALERT_TIME)
        // session strageを通過するとString型に変わるので変換する
        let extDate = typeof this.$store.state.auth.extension === 'string' ? Date.parse(this.$store.state.auth.extension) : this.$store.state.auth.extension
        if (extDate < dtDestroy) {
          // セッション有効期限切れ
          this.alertFlg = false
          this.$store.commit('auth/destroy')
          this.$router.push({name: 'Login'})
        } else if (extDate < dtAlert) {
          // セッション切れ警告 SESSION_ALERT_TIME が 0 の時は表示しない
          if (!this.alertFlg && this.$setting.SESSION_ALERT_TIME > 0) {
            // 一度のみ表示する
            this.$store.dispatch('toast/showToast', {
              title: this.$t('MESSAGE.sessionAlertTitle'),
              message: this.$t('MESSAGE.sessionAlert', [this.$setting.SESSION_ALERT_TIME]),
              variant: 'danger',
              timeout: 0
            })
            this.alertFlg = true
          }
        } else {
          this.alertFlg = false
        }
        */
      }
    }.bind(this), 10000)
  },
  methods: {
    appOnClick () {
      this.$store.commit('auth/extension')
    },
    appOnInput () {
      this.$store.commit('auth/extension')
    }
  }
}
</script>

<style>
html {
  font-size: 13px;
}
body {
  background-color: rgba(0, 0, 0, 0.02);
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 56px;
}

input::-webkit-input-placeholder {
  font-size: 1.0rem;
  color: #c0c0c0 !important;
}
input:-moz-placeholder {
  font-size: 1.0rem
}
input::-moz-placeholder {
  font-size: 1.0rem
}
input:-ms-input-placeholder {
  font-size: 1.0rem
}
.v-enter-active, .v-leave-active {
  transition: opacity .5s;
}
.v-enter, .v-leave-to {
  opacity: 0;
}

.card {
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
}
.b-toast {
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

/* ページタイトル */
.page-header-base {
  width: 100%;
}
.page-header-title {
  font-size: 1.66rem;
  font-weight: 700;
}
.page-header-title-subheading {
  font-size: 0.85rem;
  font-weight: normal;
}
.page-header-title-icon {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  float: left;
  width: 46px;
  height: 46px;
  border-radius: 5px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  vertical-align: middle;
  font-size: 24px;
  color: #fff;
  /*
  -webkit-box-shadow: 0 2px 12px -3px rgb(0 0 0 / 50%);
  box-shadow: 0 2px 12px -3px rgb(0 0 0 / 50%);
  */
  margin-right: 12px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

/* Nav */
.nav-link {
  padding: 0.5rem !important;
  color: #e0e0e0;
}
.nav-item.active {
  background-color: #17a2b8;
}
.nav-link:hover {
  color: #ffffff;
}
.nav-link .nav-icon {
    font-size: 20px !important;
    float: left;
    margin-right: 8px;
    line-height: 30px;
    width: 26px;
    text-align: center;
}
.nav-link .nav-text {
    margin: 0;
    line-height: 30px;
    font-size: 14px !important;
    position: relative;
    display: block;
    height: auto;
    white-space: nowrap;
}
.dropdown-item {
  font-size: 1.0rem;
}
.dropdown-toggle::after {
    content: none;
}

/* フォーム変更分 */
.form-group > label {
  font-weight: 700;
}
/* テキストフィールド */
.cp-textfield div[class^="col-"] {
  display: flex;
  align-items: center;
  display: block !important;
  margin-bottom: auto !important;
  margin-top: auto !important;
}
/* switchラベル */
.switch-label {
  font-size: 0.9rem;
}
/* multiSelectのborder色変更 */
.multiselect__tags {
  border: 1px solid #ced4da;
}
.is-invalid .multiselect .multiselect__tags {
  border-color: #dc3545;
}
/* 日付フィールド */
.date-width {
  min-width: 92px !important;
  max-width: 92px !important;
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}
.date-width + .input-group-append > .btn-group > .btn {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.fromto-mark .input-group-text {
  background-color: rgba(0,0,0,0.0);
  border: 0px;
}
.cp-textfield div[class^="col-"] {
  display: flex;
  align-items: center;
  display: block !important;
  margin-bottom: auto !important;
  margin-top: auto !important;
}
/* テーブル */
th {
  background-color: rgba(0, 0, 0, 0.03);
}
/* 自動必須表示 */
.form-autorequired .form-group.required > label::after {
  content: '必須';
  color: #fff;
  background-color: #dc3545;
  display: inline-block;
  padding: .25em .4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: .25rem;
  margin-left: .5em;
}
/* 自動必須表示 */
.form-autorequired .form-group.required legend::after {
  content: '必須';
  color: #fff;
  background-color: #dc3545;
  display: inline-block;
  padding: .25em .4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: .25rem;
  margin-left: .5em;
}
td {
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
}

/* 幅 */
.wpx-20 { width: 20px !important; max-width: 20px !important; }
.wpx-40 { width: 40px !important; max-width: 40px !important; }
.wpx-50 { width: 50px !important; max-width: 50px !important; }
.wpx-60 { width: 60px !important; max-width: 60px !important; }
.wpx-80 { width: 80px !important; max-width: 80px !important; }
.wpx-100 { width: 100px !important; max-width: 100px !important; }
.wpx-120 { width: 120px !important; max-width: 120px !important; }
.wpx-140 { width: 140px !important; max-width: 140px !important; }
.wpx-150 { width: 150px !important; max-width: 150px !important; }
.wpx-160 { width: 160px !important; max-width: 160px !important; }
.wpx-180 { width: 180px !important; max-width: 180px !important; }
.wpx-200 { width: 200px !important; max-width: 200px !important; }
.wpx-220 { width: 220px !important; max-width: 220px !important; }
.wpx-240 { width: 240px !important; max-width: 240px !important; }
.wpx-250 { width: 250px !important; max-width: 250px !important; }
.wpx-260 { width: 260px !important; max-width: 260px !important; }
.wpx-280 { width: 280px !important; max-width: 280px !important; }
.wpx-300 { width: 300px !important; max-width: 300px !important; }
.wpx-320 { width: 320px !important; max-width: 320px !important; }
.wpx-340 { width: 340px !important; max-width: 340px !important; }
.wpx-350 { width: 350px !important; max-width: 350px !important; }
.wpx-360 { width: 360px !important; max-width: 360px !important; }
.wpx-380 { width: 380px !important; max-width: 380px !important; }
.wpx-400 { width: 400px !important; max-width: 400px !important; }
.wpx-500 { width: 500px !important; max-width: 500px !important; }
.wpx-600 { width: 600px !important; max-width: 600px !important; }

legend {
  border-bottom: 0px !important;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/App.vue